import { Link } from "react-router-dom";

export default function ServicesThree(){
    return(
        <section id="services" class="services-area-three pb-30">
			<div class="container">
				<div class="row">
					<div class="col-lg-3 col-md-6 col-sm-6">
						<div class="single-services3 text-center mb-30">
							<img class="mb-30" src="assets/img/icon/s-3a.png" alt="Services icon" />
							<h5 class="fs-20">Machine Learning</h5>
							<p>Voice and Data Systems are
								crucial to the success</p>
							<Link to="services-details" class="read-more">Read More <i class="fal fa-long-arrow-right"></i></Link>
						</div>
					</div>
					<div class="col-lg-3 col-md-6 col-sm-6">
						<div class="single-services3 text-center mb-30">
							<img class="mb-30" src="assets/img/icon/s-3b.png" alt="Services icon" />
							<h5 class="fs-20">Artificial Intelligence</h5>
							<p>Voice and Data Systems are
								crucial to the success</p>
							<Link to="/services-details" class="read-more">Read More <i class="fal fa-long-arrow-right"></i></Link>
						</div>
					</div>
					<div class="col-lg-3 col-md-6 col-sm-6">
						<div class="single-services3 text-center mb-30">
							<img class="mb-30" src="assets/img/icon/s-3c.png" alt="Services icon" />
							<h5 class="fs-20">Augmented Reality</h5>
							<p>Voice and Data Systems are
								crucial to the success</p>
							<Link to="/services-details" class="read-more">Read More <i class="fal fa-long-arrow-right"></i></Link>
						</div>
					</div>
					<div class="col-lg-3 col-md-6 col-sm-6">
						<div class="single-services3 text-center mb-30">
							<img class="mb-30" src="assets/img/icon/s-3d.png" alt="Services icon" />
							<h5 class="fs-20">MCyber Security &amp; Data</h5>
							<p>Voice and Data Systems are
								crucial to the success</p>
                            <Link to="/services-details" class="read-more">Read More <i class="fal fa-long-arrow-right"></i></Link>
						</div>
					</div>
				</div>
			</div>
		</section>
    )
}